<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">필터</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="form_li">
              <div class="form_in">
                <div class="check_table" data-columns="2">
                  <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="RECOMMAND_POINT"
                      v-model="options.orderType"
                    /><span>추천 순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="RESPONSE_RATE"
                      v-model="options.orderType"
                    /><span>응답률 순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="CREATED_AT"
                      v-model="options.orderType"
                    /><span>신규매장 순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="CHAT_COUNT"
                      v-model="options.orderType"
                    /><span>상담건 순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="EVALUATION_SCORE"
                      v-model="options.orderType"
                    /><span>평점 순</span></label
                  >
                </div>
              </div>
            </div>
            <div class="form_li">
              <div class="form_in">
                <label class="select">
                  <select v-model="options.keyword">
                    <option :value="{ id: 0 }" selected
                      >키워드를 선택해 주세요</option
                    >
                    <option
                      v-for="keyword in sections.content"
                      :key="keyword.id"
                      :value="{ id: keyword.id, name: keyword.name }"
                      >{{ keyword.name }}</option
                    >
                  </select>
                  <span class="i_drop"></span>
                </label>
              </div>
            </div>
            <div class="form_li">
              <div class="checkbox right">
                <!--'체크박스 오른쪽 정렬: right'-->
                <label
                  ><input type="checkbox" v-model="options.follow" /><span
                    >관심매장만 보기</span
                  ></label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="$emit('close', options)">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from '@common/store/modules/keyword';
import * as keywordTypes from '@common/store/modules/keyword/types';
export default {
  props: {
    filter: Object,
  },
  data() {
    return {
      options: {
        keyword: {
          id: 0,
        },
        follow: false,
        //orderType: 'RESPONSE_RATE',
        orderType: 'RECOMMAND_POINT',
      },
    };
  },
  created() {
    this.options.keyword = this.filter.keyword || this.options.keyword;
    this.options.follow = this.filter.follow || this.options.follow;
    this.options.orderType = this.filter.orderType || this.options.orderType;
  },
  computed: {
    ...mapGetters({
      sections: keywordTypes.SECTIONS,
    }),
  },
  async mounted() {
    await this.getSections();
  },
  methods: {
    ...mapActions([keywordTypes.FETCH_SECTIONS_AREA]),
    async getSections() {
      const param = {
        emdAreaId: 4128153000,
      };
      await this[keywordTypes.FETCH_SECTIONS_AREA](param);
    },
  },
};
</script>
